import '../../../image_upload_view.js.coffee';# Added by Script 
Customer.Ticket ||= {}

class Customer.Ticket.ResponseImageView extends Monitoring.Views.ImageUploadView

  initialize: (el, response) ->
    super(el, response)
    @maxUploads =
      'fb-post': 1
      'fb-comment': 1
      'fb-message': 4
      'tweet': 4
      'direct-message': 4


  addFile:(event) =>
    super(event)
    @_resetImageUploader()
  
  _maxUploads: ->
    @_maxUploadsPerConverstion()

  _maxUploadsPerConverstion: ->
    @maxUploads[@response.ticketView.model.subType()]

  _resetImageUploader: ->
    fileInput = @$el.find('#file-image-upload-input')
    fileInput.replaceWith(fileInput.val('').clone(true));
